import React from 'react';
import { UserPermissions, PermissionScope } from '../../helpers/userAuth/userAuth';

import MethodologyIcon from '../../assets/icons/sidebar/MethodologyIcon';
import FixedPointsCategoriesIcon from '../../assets/icons/sidebar/FixedPointsCategoriesIcon';
import CanonicListsIcon from '../../assets/icons/sidebar/CanonicListsIcon';
import OrganizationIcon from '../../assets/icons/sidebar/OrganizationIcon';
import { FixedPointType } from '../../redux/models';
import YieldEstimationIcon from '../../assets/icons/sidebar/YielEstimationIcon';
import AiInsightsIcon from '../../assets/icons/sidebar/AiInsightsIcon';

const { METHODOLOGY, FIXED_POINTS, CANONICAL_CROP, ADMIN_DEVICES } = UserPermissions;
const { READ } = PermissionScope;

const options = [
  {
    key: 'methodologies',
    label: 'sidebar.methodologies',
    leftIcon: <MethodologyIcon />,
    canAccessPermission: METHODOLOGY,
    scope: READ
  },
  {
    key: 'templates',
    label: 'sidebar.template',
    leftIcon: <MethodologyIcon />,
    canAccessPermission: METHODOLOGY,
    scope: READ
  },
  {
    key: 'fixed-points-categories',
    label: 'sidebar.fixedPointsList',
    leftIcon: <FixedPointsCategoriesIcon />,
    canAccessPermission: FIXED_POINTS,
    scope: READ,
    children: [
      {
        key: `fixed-points-categories/${FixedPointType.TRAP}`,
        label: 'fixedPointType.trap'
      },
      {
        key: `fixed-points-categories/${FixedPointType.PLUVIOMETER}`,
        label: 'fixedPointType.pluviometer'
      },
      {
        key: `fixed-points-categories/${FixedPointType.GENERIC}`,
        label: 'fixedPointType.generic'
      }
    ]
  },
  {
    key: 'canonicList',
    label: 'sidebar.canonicList',
    leftIcon: <CanonicListsIcon />,
    canAccessPermission: CANONICAL_CROP,
    scope: READ,
    children: [
      {
        key: 'phenomenons',
        label: 'sidebar.phenomenon'
      },
      {
        key: 'phenomenon-categories',
        label: 'sidebar.phenomenonCategory'
      },
      {
        key: 'multiple-phenomenons-indicator',
        label: 'sidebar.multiplePhenomenonsIndicator'
      }
    ]
  },
  {
    key: 'organizations',
    label: 'sidebar.organizations',
    leftIcon: <OrganizationIcon />,
    canAccessPermission: ADMIN_DEVICES,
    scope: READ
  },
  {
    key: 'service-providers',
    label: 'sidebar.serviceProviders',
    leftIcon: <OrganizationIcon />,
    canAccessPermission: CANONICAL_CROP,
    scope: READ
  },
  {
    key: 'seeds-setup',
    label: 'sidebar.seedsSetup',
    leftIcon: <YieldEstimationIcon />,
    canAccessPermission: CANONICAL_CROP,
    scope: READ
  },
  {
    key: 'schemas',
    label: 'sidebar.schemas',
    leftIcon: <MethodologyIcon />,
    canAccessPermission: CANONICAL_CROP,
    scope: READ
  },
  {
    key: 'ai-insights',
    label: 'sidebar.aiInsights',
    leftIcon: <AiInsightsIcon />,
    canAccessPermission: CANONICAL_CROP,
    scope: READ,
    children: [
      {
        key: 'ai-insights/prompts',
        label: 'sidebar.aiInsights.prompts'
      }
    ]
  }
];

export default options;
